import {
  InvalidateQueryFilters,
  UseMutationOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { BEST_OFFER_END_POINTS } from "core/constants/endpoints";
import instance from "core/constants/request";
import { ErrorDTO, SimpleResponseDTO } from "interface";
import { specDeleteType } from "../type";

type QueryOptionsWithoutMutationFn = Omit<
  UseMutationOptions<
    SimpleResponseDTO<number>,
    AxiosError<ErrorDTO>,
    specDeleteType,
    unknown
  >,
  "mutationFn"
>;

export const useDeleteBestOffer = (options?: QueryOptionsWithoutMutationFn) => {
  const queryClient = useQueryClient();

  return useMutation<
    SimpleResponseDTO<number>,
    AxiosError<ErrorDTO>,
    specDeleteType
  >({
    retry: 0,
    ...options,
    mutationFn: async (data: specDeleteType) => {
      const result = await instance.delete<SimpleResponseDTO<number>>(
        `${BEST_OFFER_END_POINTS.delete}/${data.id}`
      );

      return result.data;
    },
    onSuccess: (res) => {
      queryClient.invalidateQueries([
        BEST_OFFER_END_POINTS.list,
      ] as InvalidateQueryFilters);
      toast.success(`آیتم با موفقیت حذف گردید`);
    },
    onError: (e: AxiosError<ErrorDTO>) => {
      toast.error(`${e.response?.data?.Message || "خطا در حذف آیتم"}`);
    },
  });
};
